import { Flow_0_0_2 } from '@flexus/core';

export const BET_77: Flow_0_0_2 = {
	id: '77',
	name: 'awaiting_auto_allocation',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for job to be allocated'
		}
	},
	startNode: '',
	nodes: {}
};
